import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { BiMailSend } from "react-icons/bi";
import { Spinner } from "react-bootstrap";
import Add from "./Add";
import DisplayEmail from "./DisplayEmail";
import GetParsedDate from "../../shared/GetParsedDate";

const TopRight = ({ moamad, newEmail, setNewEmail }) => {
  const handleButtonClick = () => {
    setNewEmail(true);
  };
  return (
    <div style={{ height: "50px", backgroundColor: "#c2c2c2" }}>
      <center>
        <button
          className="btn btn-primary navbar-btn"
          onClick={handleButtonClick}
        >
          דואר חדש <BiMailSend size={30} />
        </button>
      </center>
    </div>
  );
};

const BottomRight = ({
  moamad,
  newEmail,
  setNewEmail,
  emailToDisplay,
  setEmailToDisplay,
}) => {
  const axiosPrivate = useAxiosPrivate("application/json");
  const [loading, setLoading] = useState(true);
  const [emails, setEmails] = useState([]);
  const moamad_id = moamad.id;

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          "/jobs/moamademail?moamad_id=" + moamad_id,
          {
            signal: controller.signal,
          }
        );

        //isMounted && console.log("response.data");

        setEmails(
          response.data.sort((a, b) => {
            return b.id - a.id;
          })
        );
        setLoading(false);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [newEmail]);
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />
          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          height: "calc(100vh - 90px)",
          overflowY: "scroll",
          backgroundColor: "#f2f2f2",
        }}
      >
        {emails?.map((email) => {
          const date = new Date(email.send_date);
          const sendDate = GetParsedDate({ strDate: date, withTime: true });
          return (
            <div key={email.id}>
              <li>
                <button
                  className="small-button"
                  onClick={() => {
                    setEmailToDisplay(email);
                    setNewEmail(false);
                  }}
                >
                  {sendDate}: {email.mail_type}
                </button>
              </li>
            </div>
          );
        })}
      </div>
    );
  }
};

const LeftComponent = ({
  moamad,
  newEmail,
  emailToDisplay,
  mailTypeOptions,
  setNewEmail,
  setEmailToDisplay,
}) => (
  <div
    style={{
      height: "calc(100vh - 40px)",
      overflowY: "scroll",
      backgroundColor: "#e6e6e6",
      width: "75%",
    }}
  >
    {newEmail ? (
      <Add
        moamad={moamad}
        mailTypeOptions={mailTypeOptions}
        setNewEmail={setNewEmail}
        setEmailToDisplay={setEmailToDisplay}
      />
    ) : (
      <DisplayEmail
        email={emailToDisplay}
        moamad={moamad}
        mailTypeOptions={mailTypeOptions}
      />
    )}
  </div>
);

const RightComponent = ({
  moamad,
  newEmail,
  setNewEmail,
  emailToDisplay,
  setEmailToDisplay,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "25%" }}>
      <TopRight moamad={moamad} setNewEmail={setNewEmail} newEmail={newEmail} />
      <BottomRight
        moamad={moamad}
        setNewEmail={setNewEmail}
        newEmail={newEmail}
        emailToDisplay={emailToDisplay}
        setEmailToDisplay={setEmailToDisplay}
      />
    </div>
  );
};

const Emails = ({ visible, moamad }) => {
  const [newEmail, setNewEmail] = useState(true);
  const [emailToDisplay, setEmailToDisplay] = useState({});
  const [mailTypeOptions, setMailTypeOptions] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get("/jobs/mailtype", {
          signal: controller.signal,
        });

        //isMounted && console.log(response.data);
        setMailTypeOptions(
          response.data[0].mailtypeOptions.filter(
            (option) => option[1] !== "טופס הגשה"
          )
        );
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);
  if (!visible) return;
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <RightComponent
        moamad={moamad}
        newEmail={newEmail}
        setNewEmail={setNewEmail}
        emailToDisplay={emailToDisplay}
        setEmailToDisplay={setEmailToDisplay}
      />
      <LeftComponent
        moamad={moamad}
        newEmail={newEmail}
        emailToDisplay={emailToDisplay}
        mailTypeOptions={mailTypeOptions}
        setNewEmail={setNewEmail}
        setEmailToDisplay={setEmailToDisplay}
      />
    </div>
  );
};

export default Emails;
